import React from 'react'
import {observer} from "mobx-react"
import PlainTextCell from "./PlainTextCell";
import PropTypes from 'prop-types'
import PrintButtonCell from "./PrintButtonCell";
import ResultStatusCell from "./ResultStatusCell";
import LinkButtonCell from "./LinkButtonCell";
import ArrCell from "./ArrCell";
import PrintModalCell from "./PrintModalCell/PrintModalCell";
import LinkCell from "./LinkCell/LinkCell";
import LinkCell2 from "./LinkCell2/LinkCell2";
import CheckboxCell from "./CheckboxCell";
import UploadLists from "./UploadLists/UploadLists";
import EmailSendCell from "./EmailSendCell";
import LinkToOrgPatients from "./LinkToOrgPatients";
import ToCalendar from "./ToCalendar/ToCalendar";
import ToMedCentersOrOrg from "./ToMedCentersOrOrg";
import ToPatients from "./ToPatients";
import EmailSendCell2 from "./EmailSendCell2";
import UploadLists2 from "./UploadLists/UploadLists2";
import UploadLists3 from "./UploadLists/UploadLists3";
import ReactRouterCell from "./ReactRouterCell";
import WrapperCell from "./WrappperCell";

const CellSwitcher = observer((props) => {
    switch (props.type) {
        case 'plainTextCell':
            return <PlainTextCell cellContent={props.cellContent}/>
        case 'printButtonCell':
            return <PrintButtonCell cellData={props.typeData} cellContent={props.cellContent}/>
        case 'resultStatusCell':
            return <ResultStatusCell cellData={props.typeData} cellContent={props.cellContent}/>
        case 'linkButtonCell':
            return <LinkButtonCell cellData={props.typeData} cellContent={props.cellContent}/>
        case 'arrCell':
            return <ArrCell cellData={props.typeData} cellContent={props.cellContent}/>
        case 'printModalCell':
            return <PrintModalCell idArr={props.idArr} cellData={props.typeData} cellContent={props.cellContent}/>
        case 'linkCell':
            return <LinkCell idArr={props.idArr} cellData={props.typeData} cellContent={props.cellContent}/>
        case 'linkCell2':
            return <LinkCell2 idArr={props.idArr} cellData={props.typeData} cellContent={props.cellContent}/>
        case 'reactRouterCell':
            return <ReactRouterCell idArr={props.idArr} cellData={props.typeData} cellContent={props.cellContent}/>
        case 'checkboxCell':
            return <CheckboxCell idArr={props.idArr} cellData={props.typeData} cellContent={props.cellContent}/>
        case 'uploadLists':
            return <UploadLists idArr={props.idArr} cellData={props.typeData} cellContent={props.cellContent}/>
        case 'uploadLists2':
            return <UploadLists2 idArr={props.idArr} cellData={props.typeData} cellContent={props.cellContent}/>
        case 'uploadLists3':
            return <UploadLists3 idArr={props.idArr} cellData={props.typeData} cellContent={props.cellContent}/>
        case 'emailSend':
            return <EmailSendCell idArr={props.idArr} cellData={props.typeData} cellContent={props.cellContent}/>
        case 'wrapperCell':
            return <WrapperCell all={props.all} idArr={props.idArr} cellData={props.typeData}
                                cellContent={props.cellContent}/>
        case 'emailSend2':
            return <EmailSendCell2 idArr={props.idArr} cellData={props.typeData} cellContent={props.cellContent}/>
        case 'linkToOrgPatients':
            return <LinkToOrgPatients idArr={props.idArr} cellData={props.typeData} cellContent={props.cellContent}/>
        case 'toCalendar':
            return <ToCalendar idArr={props.idArr} cellData={props.typeData} cellContent={props.cellContent}/>
        case 'toMedCentersOrOrg':
            return <ToMedCentersOrOrg idArr={props.idArr} cellData={props.typeData} cellContent={props.cellContent}/>
        case 'toPatients':
            return <ToPatients idArr={props.idArr} cellData={props.typeData} cellContent={props.cellContent}/>

        default:
            return <PlainTextCell cellContent={props.cellContent}/>
    }

})
CellSwitcher.propTypes = {
    type: PropTypes.string,
    typeData: PropTypes.object
}


export default CellSwitcher
